import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Documents from './Documents';
import Remark from './Remark';
import { observer } from 'mobx-react';

const Footer = observer(({ bol }) => {
  const { detail, whsDocuments, pandaDocuments } = bol;
  return <Box mt={5}>
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Documents whsDocuments={whsDocuments} pandaDocuments={pandaDocuments} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Remark detail={detail} />
      </Grid>
    </Grid>
  </Box>
})

export default Footer;
